import axios from 'axios'
import store from '@/store'
import wxconnfig from '../utils/config'
import JSONBIG from 'json-bigint'

let baseURL
switch (process.env.NODE_ENV) {
  case 'production':
    baseURL = 'https://sienapi.da300.com'
    break
  case 'development':
    // baseURL = 'https://c9f69d003467.ngrok.io'
    baseURL = 'https://sienapi.da300.com'
    break
  default:
    baseURL = '127.0.0.1'
    break
}
// create an axios instance
const service = axios.create({
  // baseURL: 'https://c7a30ed052d8.ngrok.io', // url = base url + request url
  // baseURL: 'https://sienapi.da300.com', // url = base url + request url
  baseURL: baseURL, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 8 * 1000 // request timeout
})

service.defaults.transformResponse = [data => {
  // 对data（后台的原始数据）进行转换
  return JSONBIG.parse(data)
}]

// request interceptor
service.interceptors.request.use(
  config => {
    let token = store.token || sessionStorage.getItem('token')
    if (token) {
      config.headers['token'] = token
    }
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    // const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    // if (res.code !== 200) {
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
    //   return res
    // }
    // if (res.code === 'token过期') {
    //   alert('登录过期，请重登录')
    //   store.token = null
    //   for (let i in store.user) {
    //     store.user[i] = null
    //   }
    //   localStorage.clear()
    //   window.location.replace(location.origin)
    // }
    return response
  },
  error => {
    console.log('err' + error) // for debug
    if (error.response) {
      switch (error.response.status) {
        case 401:
          alert('登录过期,请重登录')
          sessionStorage.clear()
          location.replace(wxconnfig.orginUrl)
          break
        case 403:
          // (一般token过期了)
          break
        case 404:
          break
      }
    } else {
      alert('数据获取失败~')
      console.log(error)
      // return Promise.reject(error)
      return {data: null}
    }
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js